import { render, staticRenderFns } from "./OurServicePage.vue?vue&type=template&id=7cd6dba0&scoped=true"
import script from "./OurServicePage.vue?vue&type=script&lang=js"
export * from "./OurServicePage.vue?vue&type=script&lang=js"
import style0 from "./OurServicePage.vue?vue&type=style&index=0&id=7cd6dba0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd6dba0",
  null
  
)

export default component.exports